import React from 'react';
import { observer } from "mobx-react";

import {
  BaseModelCollection,
  AppState,
  File,
  getFiles,
  getAppState,
} from '../models';

import {
  BaseCollectionPage,
} from './BaseCollectionPage';
import { TextField, List, Subheader, ListItem, Button } from "react-md";
import { getApi } from "../api";
import HelpView from "../components/HelpView";


interface FilesProps {
  history?: any;
  match?: any;
  location?: any;
}

type ComponentState = any;



@observer
class Files extends BaseCollectionPage<FilesProps, ComponentState> {
  viewName = 'Files';
  objectName = 'file';
  store = 'my_models';

  get objectLabel() {
    return "File";
  }

  

  
  

  

  getCollection(): BaseModelCollection {
    return getFiles();
  }

  getAppState(): AppState {
    return getAppState();
  }

  get customFilters(): any[] {
    let filters: any = []
    
      filters = ["created_by","attached_to_task","attached_to_note","attached_to_contact","attached_to_client"]
    

    let customFilters: any[] = [];

    let obj = new File();
    filters.forEach((key: string) => {
      let field = obj.getFieldInfo(key);
      if (!field) return;

      let filter: any = {
        key: key,
        label: field.label,
        type: field.type,
      };

      if ((field.type == 'model') || (field.type == 'models')) {
        filter['collectionName'] = field.objectName;
      }

      if (field.type == 'select') {
        filter['options'] = field.options;
      }

      customFilters.push(filter);
    })

    return customFilters;
  }

  

  

  

  
  


}

export default Files;